import { IVirtualDevice } from "../interfaces/IVirtualDevice";

export default class VirtualDevice implements IVirtualDevice
{
  deviceID: string;
}
